import React, { useState, useEffect } from "react";
import {
  Grid,
  Container,
  TextField,
  Typography,
  Button,
  Snackbar,
  Alert,
} from "@mui/material";
import { useHistory } from "react-router-dom";
import Header from "../Component/Header";
import Footer from "../Component/Footer";
import SubFooter from "../Component/SubFooter";
import NewsletterCard from "../Component/NewsletterCard";
import axios from "axios";
import config from "../config";

function ChangePassword() {
  const history = useHistory();
  const [openAlert, setOpenAlert] = useState(false);
  const [msgAlert, setMsgAlert] = useState("");
  const [loading, setLoading] = useState(false);
  const [isData, setIsData] = useState({
    password: "",
    code: "",
  });

  const handleClose = () => {
    setOpenAlert(false);
  };
  /* eslint-disable */
  useEffect(() => {
    const url = new URL(window.location.href);
    const code = url.searchParams.get("code");
    setIsData({
      ...isData,
      code: code.toString(),
    });
  }, []);

  const onClick = () => {
    setLoading(true);
    axios
      .patch(`${config.url}/forgot_passwords`, isData, config.token)
      .then((res) => {
        setMsgAlert("Success reset to new password");
        setOpenAlert(true);
        setLoading(false);
        setTimeout(() => {
          history.push("/login");
        }, 3000);
      })
      .catch((e) => {
        setMsgAlert(e.response.data.data);
        setOpenAlert(true);
        setLoading(false);
      });
  };
  return (
    <React.Fragment>
      <Header />
      <Container maxWidth="xl" sx={{ mt: "30px" }}>
        <Grid container>
          <Grid item xs={1} lg={3} />
          <Grid
            item
            xs={10}
            lg={6}
            sx={{
              border: "1px solid #ddd",
              textAlign: "center",
              minHeight: "400px",
              pt: "20px",
              mb: "40px",
              pl: "20px",
              pr: "20px",
            }}
          >
            <Grid item xs={12}>
              <Typography variant="h5">Reset Password</Typography>
              <Typography variant="body1">
                Please change your password below.
              </Typography>
            </Grid>
            <Grid item xs={12} sx={{ mt: "50px" }}>
              <TextField
                id="outlined-basic"
                variant="outlined"
                label="New Password"
                fullWidth
                size="small"
                type="password"
                required
                onChange={(e) =>
                  setIsData({
                    ...isData,
                    password: e.target.value,
                  })
                }
              />
            </Grid>
            <Grid item xs={12} sx={{ mt: "20px" }}>
              <Button
                variant="contained"
                style={{ background: "#cc0600" }}
                fullWidth
                onClick={onClick}
              >
                Reset
              </Button>
            </Grid>
          </Grid>
          <Grid item xs={1} lg={3} />
        </Grid>
        <Snackbar
          open={openAlert}
          autoHideDuration={4000}
          onClose={handleClose}
        >
          <Alert severity="error">{msgAlert}</Alert>
        </Snackbar>
      </Container>
      <NewsletterCard />
      <Footer />
      <SubFooter />
    </React.Fragment>
  );
}

export default ChangePassword;
